module.exports = __webpack_public_path__ + "img/index_bg.c8286019.jpg";